import React, {createContext, useEffect, useState, useContext, useMemo} from 'react';
import {
    GoogleAuthProvider,
    signInWithPopup,
    onAuthStateChanged,
    signOut,
} from 'firebase/auth';

import {auth} from '../firebase';

const provider = new GoogleAuthProvider();

const AuthContext = createContext({});

export const AuthProvider = ({children}) => {
    
    const AllowedUser = [
        'bhavyagoyal54@gmail.com',
        'goel.rajiv75@gmail.com',
        'auctionpoint8@gmail.com',
        'auctionpoint9@gmail.com'
    ]

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true)
    
    useEffect(() => onAuthStateChanged(auth, async user => {
        if(user)
        {
            // console.log(user)
            if(AllowedUser.includes(user.email.toLowerCase()))
            {
                setUser(user)
            }
            else
                logout()
        }
        
        setLoading(false)
    }), [])

    const signIn = async () => {
        try{
            const results = await signInWithPopup(auth, provider)
            
        }
        catch {

        }
    }

    const logout = () => {
        signOut(auth)
        .finally(() => setUser(null))
    }

    const memo = useMemo(() => ({
        user,
        signIn,
        logout
    }), [user])

    return (
        <AuthContext.Provider value={memo}>
            {!loading && children}
        </AuthContext.Provider>
    )
}

export default function useAuth(){
    return useContext(AuthContext)
}
